"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileUploaderWrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-confusing-arrow */
var FileUploaderWrapper = _styledComponents.default.div.withConfig({
  displayName: "FileUploaderstyles__FileUploaderWrapper",
  componentId: "rhj2qw-0"
})(["cursor:", ";.c-file-uploader-drop-zone{border:", " dashed ", ";border-radius:1.5rem;margin:1rem 0;}.c-file-uploader-inner-wrapper{margin-top:1rem;margin-bottom:1rem;display:flex;flex-direction:column;justify-content:center;align-content:center;align-items:center;}.c-file-uploader-text{color:", ";}.c-file-uploader-browse-files{color:", ";font-weight:", ";&:hover{text-decoration:", ";}}.c-file-uploader-caption{padding:0;}"], function (props) {
  return props.isDisabled ? 'not-allowed' : 'pointer';
}, function (props) {
  return props.theme.thinLine;
}, function (props) {
  return props.isDisabled ? props.theme.c_foreground_primary_medLight : props.theme.c_foreground_primary;
}, function (props) {
  return props.isDisabled ? props.theme.c_foreground_disabled : props.theme.c_foreground_default;
}, function (props) {
  return props.isDisabled ? props.theme.c_foreground_primary_medLight : props.theme.c_foreground_primary;
}, function (props) {
  return props.theme.primaryHeavy;
}, function (props) {
  return props.isDisabled ? 'none' : 'underline';
});

exports.FileUploaderWrapper = FileUploaderWrapper;